import HttpService from './HttpService';

export default class TranslationService extends HttpService {
    endPoint = "/v1/translations"

    getDefault() {
        return this.getJsonRequest().get(this.endPoint + "/default");
    }

    getProfileAndDefault() {
        return this.getAuthTokenRequest().get(this.endPoint + "/profile-and-default");
    }

    getCoreTranslations() {
        return this.getAuthTokenRequest().get(this.endPoint + "/core");
    }

    getProfileTranslations() {
        return this.getAuthTokenRequest().get(this.endPoint + "/profile");
    }
}

